import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PATHS } from '../../common/constants';
import WithNavigation from '../../layouts/WithNavigation';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import Breadcrumb from '../../components/Breadcrumb';
import Card from '../../components/Card';
import Avatar from '../../components/Avatar';
import Tenant from '../../components/Tenant';
import Tabs from '../../components/Tabs';
import CommonAreaServiceRequests from './CommonAreaServiceRequests';
import {
  selectCommonAreaById,
  selectPropertyCommonAreas,
} from '../../store/selectors/propertyCommonAreas';
import { selectPropertyById } from '../../store/selectors/properties';
import CommonAreaAssets from './CommonAreaAssets';
import { fetchCommonAreaAssets } from '../../store/actions/CommonAreaAssets';
import { selectCommonAreaAssets } from '../../store/selectors/commonAreaAssets';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
// import variables from '../../styles/includes/variables.scss';

import { variables } from '../../Tenants';
import { onRequestPhoneCall } from '../../helpers/validationHelper';

class CommonArea extends Component {
  state = {
    isOpen: false,
  };

  componentDidMount() {
    const { onFetchCommonAreaAssets, match, propertyCommonAreas } = this.props;
    let commonAreaId = match.params.id.split('&')[0];
    if (propertyCommonAreas && propertyCommonAreas.commonAreas) {
      let commonArea = propertyCommonAreas.commonAreas.filter(
        (s) => s.id === commonAreaId
      )[0];
      onFetchCommonAreaAssets(commonArea.id);
    }
  }

  render() {
    const {
      property,
      commonAreaAssets,
      serviceRequests,
      propertyCommonAreas,
      match,
    } = this.props;
    const { isOpen } = this.state;
    let commonAreaId = match.params.id.split('&')[0];
    let commonArea = propertyCommonAreas.commonAreas.filter(
      (s) => s.id === commonAreaId
    )[0];
    return (
      <WithNavigation
        title={
          commonArea.customLabel ? commonArea.customLabel : commonArea.name
        }
        top={
          <HeadingWithDetails
            style={{
              backgroundImage: `url(/assets/banner-property.png)`,
            }}
            breadcrumb={
              <Breadcrumb
                to={PATHS.PROPERTIES_VIEW.replace(':id', property.id)}
                label={property.name}
              />
            }
            headline={
              commonArea.customLabel ? commonArea.customLabel : commonArea.name
            }
            items={[
              <Card
                title={variables.propertyDeveloper}
                body={
                  property.propertyManager &&
                  property.propertyManager.firstname ? (
                    <Tenant
                      headline={
                        <a
                          href={PATHS.CONTACTS_VIEW.replace(
                            ':id',
                            property.propertyManager.id
                          )}
                        >
                          {property.propertyManager.firstname}{' '}
                          {property.propertyManager.lastname}
                        </a>
                      }
                      strapline={onRequestPhoneCall(
                        property.propertyManager.phone
                      )}
                      avatar={
                        <div
                          onClick={() =>
                            this.setState({
                              isOpen: property.propertyManager.profileImage
                                ? true
                                : false,
                            })
                          }
                        >
                          <Avatar
                            badge="property-manager"
                            url={property.propertyManager.profileImage}
                          />
                          {isOpen && isOpen === true ? (
                            <Lightbox
                              open={isOpen}
                              close={() => this.setState({ isOpen: false })}
                              slides={[
                                { src: property.propertyManager.profileImage },
                              ]}
                              plugins={[Zoom]}
                            />
                          ) : null}
                        </div>
                      }
                    />
                  ) : (
                    <div style={{ textAlign: 'center' }}> Unassigned </div>
                  )
                }
              />,
              <Card
                title="Strata Manager"
                body={
                  property.strataManager && property.strataManager.firstname ? (
                    <Tenant
                      headline={
                        <a
                          href={PATHS.CONTACTS_VIEW.replace(
                            ':id',
                            property.strataManager.id
                          )}
                        >
                          {property.strataManager.firstname}{' '}
                          {property.strataManager.lastname}
                        </a>
                      }
                      strapline={onRequestPhoneCall(
                        property.strataManager.phone
                      )}
                      avatar={
                        <div
                          onClick={() =>
                            this.setState({
                              isOpen: property.strataManager.profileImage
                                ? true
                                : false,
                            })
                          }
                        >
                          <Avatar
                            badge="strata-manager"
                            url={property.strataManager.profileImage}
                          />
                          {isOpen && isOpen === true ? (
                            <Lightbox
                              open={isOpen}
                              close={() => this.setState({ isOpen: false })}
                              slides={[
                                { src: property.strataManager.profileImage },
                              ]}
                              plugins={[Zoom]}
                            />
                          ) : null}
                        </div>
                      }
                    />
                  ) : (
                    <div style={{ textAlign: 'center' }}> Unassigned </div>
                  )
                }
              />,
            ]}
          />
        }
        bottom={
          <Tabs
            from={'CommonArea'}
            items={[
              {
                label: 'Assets',
                count: commonAreaAssets.length.toString(),
                content: (
                  <CommonAreaAssets
                    commonArea={commonArea}
                    property={property}
                  />
                ),
              },
              {
                label: 'Service Requests',
                count: serviceRequests.length.toString(),
                content: (
                  <CommonAreaServiceRequests
                    commonArea={commonArea}
                    property={property}
                  />
                ),
              },
            ]}
          />
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let commonAreaId = ownProps.match.params.id.split('&')[0];
  let propertyId = ownProps.match.params.id.split('&')[1];

  return {
    propertyCommonAreas: selectPropertyCommonAreas(state),
    property: selectPropertyById(state, propertyId),
    commonAreaAssets: selectCommonAreaAssets(state),
    serviceRequests: selectServiceRequests(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchCommonAreaAssets: fetchCommonAreaAssets,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CommonArea);
